<template>
  <div id="page-job-item-list">
    <div>
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :focused-row-index="0"
          :show-borders="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          :ref="gridRefKey"
        >
          >
          <dx-paging :page-size="20" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />
          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="90"
            :hiding-priority="1"
            :visible="false"
          />
          <dx-column
            data-field="referenceNumber"
            :caption="this.$t('JobItem.ReferenceNumber')"
            :hiding-priority="98"
          />
          <dx-column
            data-field="title"
            :caption="this.$t('JobItem.Title')"
            :hiding-priority="99"
          />
          <dx-column
            data-field="date"
            :caption="this.$t('JobItem.Date')"
            :hiding-priority="98"
            data-type="date"
          />
          <dx-column
            data-field="url"
            :caption="this.$t('JobItem.Url')"
            :hiding-priority="1"
            data-type="url"
          >
          </dx-column>
          <dx-column
            data-field="isDeleted"
            :caption="this.$t('IsDeleted')"
            :width="190"
            :hiding-priority="7"
            data-type="boolean"
          />
          <dx-column
            data-field="categories"
            :caption="this.$t('JobItem.Categories')"
            :width="190"
            :hiding-priority="6"
          >
          </dx-column>
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import moduleJobFeedManagement from '@/store/job-feed-management/moduleJobFeedManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import { DxPopup } from 'devextreme-vue/popup'
import { notifyMixin } from '@/mixins/notifyMixin'

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  DxEditing,
  DxPosition,
  DxForm,
  DxPopup as DxGridPopup
} from 'devextreme-vue/data-grid'

import { DxItem } from 'devextreme-vue/form'

const gridRefKey = "grid-job-items"
export default {
  name: 'job-item-list',
  mixins: [notifyMixin],
  props: {
    jobFeedId: {
      type: Number
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    DxEditing,
    DxPopup,
    DxPosition,
    DxForm,
    DxItem,
    DxGridPopup,
  },
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store
          .dispatch(
            'jobFeedManagement/fetchJobItems',
            this.jobFeedId
          )
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      update: (key, values) => {
        return this.$store
          .dispatch('jobFeedManagement/saveJobItem', {
            id: key,
            ...values
          })
          .then( () => {
            this.notifySuccess(this.$t('RecordUpdated'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      remove: (key) => {
        return this.$store
          .dispatch('jobFeedManagement/deleteJobItem', key)
          .then(() => {
            this.notifySuccess(this.$t('RecordDeleted'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    const editButtons = ['edit', 'delete']

    return {
      customDataSource,
      gridRefKey,
      editButtons
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    refreshGrid () {
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    }
  },
  mounted () { },
  created () {
    if (!moduleJobFeedManagement.isRegistered) {
      this.$store.registerModule(
        'jobFeedManagement',
        moduleJobFeedManagement
      )
      moduleJobFeedManagement.isRegistered = true
    }

  }
}
</script>

<style lang="scss">
#page-job-item-list {
  .job-item-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>